import { ConversionService } from 'src/app/services/conversion.service';
import { RoutingProfile } from 'src/app/_models/daws/trip';
import { RoutingProfileModel } from 'src/app/_models/profilews/profilews';
import { VehicleConfigurationString } from '../_models/vehicleConfigurationString';
import { RouteState } from 'src/app/_models/state/routeState';

export function getVehicleConfig(
  data: RouteState,
  profile: RoutingProfileModel,
  conversationService: ConversionService
) {
  const vehicle: VehicleConfigurationString = {} as VehicleConfigurationString;
  const vehicleConfig = profile?.vehicleOptions?.vehicleConfig;
  const distanceUnit = data?.optionsState?.distanceUnits;
  if (profile.units === 0) {
    if (distanceUnit === 0) {
      if (vehicleConfig) {
        vehicle.height = conversationService.totalInchesToString(
          vehicleConfig?.height,
          false
        );

        vehicle.width = conversationService.totalInchesToString(
          vehicleConfig?.width,
          true
        );

        vehicle.length = conversationService.totalInchesToString(
          vehicleConfig?.length,
          false
        );

        vehicle.weight = `${vehicleConfig?.weight.toLocaleString()} lbs`;
        vehicle.axles = data?.optionsState?.trkAxles;
      }
    } else {
      if (vehicleConfig) {
        vehicle.height = `${conversationService.inchesToMeters(
          vehicleConfig?.height,
          2
        )}m`;
        vehicle.width = `${conversationService.inchesToMeters(
          vehicleConfig?.width,
          2
        )}m`;
        vehicle.length = `${conversationService.inchesToMeters(
          vehicleConfig?.length,
          2
        )}m`;
        vehicle.weight = `${conversationService
          .poundsToKilograms(vehicleConfig?.weight, 2)
          .toLocaleString()} kgs`;
        vehicle.axles = data?.optionsState?.trkAxles;
      }
    }
    return vehicle;
  }
  if (profile.units === 1) {
    if (distanceUnit === 0) {
      if (vehicleConfig) {
        const totalHeightInches = conversationService.metersToInches(
          vehicleConfig?.height / 100
        );
        vehicle.height = conversationService.totalInchesToString(
          totalHeightInches,
          false
        );
        const totalWidthInches = conversationService.metersToInches(
          vehicleConfig?.width / 100
        );
        vehicle.width = conversationService.totalInchesToString(
          totalWidthInches,
          true
        );
        const totalLengthInches = conversationService.metersToInches(
          vehicleConfig?.length / 100
        );
        vehicle.length = conversationService.totalInchesToString(
          totalLengthInches,
          false
        );
        vehicle.weight = `${conversationService
          .kilogramsToPounds(vehicleConfig?.weight)
          .toLocaleString()} lbs`;
        vehicle.axles = data?.optionsState?.trkAxles;
      }
    } else {
      if (vehicleConfig) {
        vehicle.height = `${vehicleConfig?.height / 100}m`;
        vehicle.width = `${vehicleConfig?.width / 100}m`;
        vehicle.length = `${vehicleConfig?.length / 100}m`;
        vehicle.weight = `${vehicleConfig?.weight.toLocaleString()} kgs`;
        vehicle.axles = data?.optionsState?.trkAxles;
      }
    }
    return vehicle;
  }
}
